module.exports = __webpack_public_path__ + "img/55.4464ed91.jpg";